import React from 'react';

export const forceMajeureMessages = {
  value: 'Force Majeure',
  list: [
    {
      value: (
        <>
          Without prejudice to the provisions of these Terms and Conditions
          limiting or disclaiming liability, Glints is not liable for any delay
          or failure in performance resulting directly or indirectly from causes
          beyond its reasonable control, including, without limitation, failure
          of the internet, power failure, failure of computer, telecommunication
          or other equipment, strikes, labor disputes, riots, insurrections,
          civil disturbances, shortage of labor or materials, fires, floods,
          storms, explosions, act of God, war, governmental actions, orders of
          domestic or foreign courts and non-performance of third parties.
        </>
      ),
    },
  ],
};
